var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m.757289.757359 8.485281 8.485281m0-8.485281-8.485281 8.485281","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Cross.defaultProps = {"fill":"none","height":"10","viewBox":"0 0 10 10","width":"10"};

module.exports = Cross;

Cross.default = Cross;
